import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid } from '@mui/material';
import { AlertWidget } from '../../../widgets';
import Board, { moveCard } from '@lourenci/react-kanban';
import '@lourenci/react-kanban/dist/styles.css';
import '../template/styles.css';

const board = {
  columns: [
    {
      id: 1,
      title: 'Actividades',
      cards: [
        {
          id: 1,
          title: 'Card title 1',
          description: 'Card content',
        },
        {
          id: 2,
          title: 'Card title 2',
          description: 'Card content',
        },
        {
          id: 3,
          title: 'Card title 3',
          description: 'Card content',
        },
      ],
    },
    {
      id: 2,
      title: 'Entregadas',
      cards: [
        {
          id: 9,
          title: 'Card title 9',
          description: 'Card content',
        },
      ],
    },
    // {
    //   id: 3,
    //   title: "Q&A",
    //   cards: [
    //     {
    //       id: 10,
    //       title: "Card title 10",
    //       description: "Card content"
    //     },
    //     {
    //       id: 11,
    //       title: "Card title 11",
    //       description: "Card content"
    //     }
    //   ]
    // },
    {
      id: 4,
      title: 'Evaluadas',
      cards: [
        {
          id: 12,
          title: 'Card title 12',
          description: 'Card content',
        },
        {
          id: 13,
          title: 'Card title 13',
          description: 'Card content',
        },
      ],
    },
  ],
};

function ControlledBoard() {
  // You need to control the state yourself.
  const [controlledBoard, setBoard] = React.useState(board);

  function handleCardMove(_card, source, destination) {
    const updatedBoard = moveCard(controlledBoard, source, destination);
    setBoard(updatedBoard);
  }

  return (
    <Board onCardDragEnd={handleCardMove} disableColumnDrag>
      {controlledBoard}
    </Board>
  );
}

function UncontrolledBoard() {
  return (
    <Board
      allowRemoveLane
      allowRenameColumn
      allowRemoveCard
      onLaneRemove={console.log}
      onCardRemove={console.log}
      onLaneRename={console.log}
      initialBoard={board}
      allowAddCard={{ on: 'top' }}
      onNewCardConfirm={(draftCard) => ({
        id: new Date().getTime(),
        ...draftCard,
      })}
      onCardNew={console.log}
      // renderColumnHeader={({ title }, { removeColumn, renameColumn, addCard }) => (
      //   <div>
      //     {title}
      //     <button type='button' onClick={removeColumn}>Remove Column</button>
      //     <button type='button' onClick={() => renameColumn('New title')}>Rename Column</button>
      //     <button type='button' onClick={() => addCard({ id: 99, title: 'New Card' })}>Add Card</button>
      //   </div>
      // )}
      // renderCard={({ content }, { removeCard, dragging }) => {

      //   console.log(content)

      //   return (
      //     <div dragging={dragging}>
      //       {content}
      //       <button type="button" onClick={removeCard}>Remove Card</button>
      //     </div>
      //   )
      // }}
    />
  );
}

const TableroAdminView = () => {
  const dispatch = Redux.useDispatch();

  const tableroStore = Redux.useSelector((state) => state.tablero);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const [isStudent, setIsStudent] = React.useState(false);

  React.useEffect(() => {
    setIsStudent(estudiantesStore.activo !== null);
  }, [estudiantesStore.activo]);

  return (
    <Grid container spacing={1}>
      <AlertWidget alert={tableroStore.alertView} />
      <Grid item md={12}>
        <UncontrolledBoard />
      </Grid>
    </Grid>
  );
};

export default TableroAdminView;
